import React from 'react'
import PropTypes from "prop-types";
import './featured.scss';

const Featured = ({featured}) => (
  <span className="featured">
    <span className={`featured__item featured__item--${featured}`}>{featured}</span>
  </span>
);

Featured.propTypes = {
  featured: PropTypes.string,
};

export default Featured



// WEBPACK FOOTER //
// ./src/components/featured/featured.js